import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IAddresProps {
  address: string;
}

export const Address: React.FC<IAddresProps> = ({ address }) => {
  return (
    <div className={styles['container']}>
      <UIText2 color="black_60">{address}</UIText2>
    </div>
  );
};
